/**
 * @module lib/obj
 */

/**
 * Utility function to apply `Object.freeze(Object.assign(...))`
 *
 * @param {object} target The target object to assign to
 * @param  {...object} sources One or more objects to assign properties onto {@link target}
 * @returns {object} A mutated instance of {@link target} that has been been frozen
 */
export const freezign = (target, ...sources) => Object.freeze(Object.assign(target, ...sources));
